import React, { useState, useEffect } from "react";
import GroupCard from "../components/Group/GroupCard";
import useCRUD from "../hooks/useCRUD";
import Pagination from "../components/Elements/Pagination";

const GROUPS_PER_PAGE = 6;

const Groups = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { data: groups, fetchItems: getGroups } = useCRUD(
    "/api/participant-groups",
  );

  useEffect(() => {
    getGroups().catch((err) => {
      console.error("Error fetching groups:", err);
    });
  }, [getGroups]);

  const totalGroups = groups?.length || 0;
  const totalPages = Math.max(1, Math.ceil(totalGroups / GROUPS_PER_PAGE));
  const page = Math.min(currentPage, totalPages);
  const pagedGroups = groups?.slice(
    (page - 1) * GROUPS_PER_PAGE,
    page * GROUPS_PER_PAGE,
  );

  return (
    <div className="min-h-screen bg-gray-100 px-4 py-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-5 rounded-xl bg-white p-5 shadow-lg sm:flex sm:items-center sm:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#004a7e]">
              Participant groups
            </p>
            <h1 className="mt-2 text-2xl font-black text-gray-900 sm:text-3xl">
              My Groups
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              Manage imported participant lists and event groups from one place.
            </p>
          </div>
          <span className="mt-4 inline-flex rounded-md bg-[#eaf3fa] px-3 py-1 text-xs font-bold text-[#004a7e] sm:mt-0">
            {totalGroups} {totalGroups === 1 ? "group" : "groups"}
          </span>
        </div>

        {groups && groups.length > 0 ? (
          <>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
              {pagedGroups.map((group) => (
                <GroupCard key={group.id} group={group} />
              ))}
            </div>
            <Pagination
              currentPage={page}
              totalItems={totalGroups}
              itemsPerPage={GROUPS_PER_PAGE}
              onPageChange={setCurrentPage}
              label="groups"
            />
          </>
        ) : (
          <p className="rounded-xl bg-white p-8 text-center text-gray-600 shadow-sm">
            No groups found. Start by creating a new event.
          </p>
        )}
      </div>
    </div>
  );
};

export default Groups;
